import React from "react";
import "./WebsiteSupported.css";
import { useApp } from "../../AppContext/AppContext";

const WebsiteSupported = () => {
  const { handleAppSelect, currentColor } = useApp();

  const handleSiteClick = (siteName) => {
    handleAppSelect(siteName);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="supported-sites">
      <h2 className="supported-sites__title" >
        Popular website <span style={{ color: currentColor }}> Supported</span>
      </h2>
      <p className="supported-sites__subtitle">
        Effortless Video Downloads at Your Fingertips
      </p>

      <div className="supported-sites__grid">
        <div 
          className="supported-site"
          onClick={() => handleSiteClick('Instagram')}
          style={{ cursor: 'pointer' }}
        >
          <img
            src="/assets/insta.svg"
            alt=""
            className="supported-site__icon"
          />
          <span className="supported-site__name">Instagram</span>
        </div>

        <div 
          className="supported-site"
          onClick={() => handleSiteClick('Facebook')}
          style={{ cursor: 'pointer' }}
        >
          <img
            src="/assets/facebook.svg"
            alt=""
            className="supported-site__icon"
          />
          <span className="supported-site__name">Facebook</span>
        </div>

        <div 
          className="supported-site"
          onClick={() => handleSiteClick('Tiktok')}
          style={{ cursor: 'pointer' }}
        >
          <img
            src="/assets/tiktok.svg"
            alt=""
            className="supported-site__icon"
          />
          <span className="supported-site__name">Tiktok</span>
        </div>

        <div 
          className="supported-site"
          onClick={() => handleSiteClick('Dailymotion')}
          style={{ cursor: 'pointer' }}
        >
          <img
            src="/assets/dailymotion.svg"
            alt=""
            className="supported-site__icon"
          />
          <span className="supported-site__name">Dailymotion</span>
        </div>

        <div 
          className="supported-site"
          onClick={() => handleSiteClick('X-twitter')}
          style={{ cursor: 'pointer' }}
        >
          <img
            src="/assets/twitter.svg"
            alt=""
            className="supported-site__icon"
          />
          <span className="supported-site__name">X-twitter</span>
        </div>

        <div 
          className="supported-site"
          onClick={() => handleSiteClick('IMDb')}
          style={{ cursor: 'pointer' }}
        >
          <div className="supported-site__imdb">IMDb</div>
          <span className="supported-site__name">IMDb</span>
        </div>

        <div 
          className="supported-site"
          onClick={() => handleSiteClick('Likee')}
          style={{ cursor: 'pointer' }}
        >
          <img
            src="/assets/likee.svg"
            alt=""
            className="supported-site__icon"
          />
          <span className="supported-site__name">Likee</span>
        </div>

        {/* <div 
          className="supported-site"
          onClick={() => handleSiteClick('Bitchute')}
          style={{ cursor: 'pointer' }}
        >
          <img
            src="/assets/bitchute.svg"
            alt=""
            className="supported-site__icon"
          />
          <span className="supported-site__name">Bitchute</span>
        </div> */}

        <div 
          className="supported-site"
          onClick={() => handleSiteClick('Thread')}
          style={{ cursor: 'pointer' }}
        >
          <img
            src="/assets/thread.svg"
            alt=""
            className="supported-site__icon"
          />
          <span className="supported-site__name">Thread</span>
        </div>

        {/* <div 
          className="supported-site"
          onClick={() => handleSiteClick('Veoh')}
          style={{ cursor: 'pointer' }}
        >
          <img
            src="/assets/veoh.svg"
            alt=""
            className="supported-site__icon"
          />
          <span className="supported-site__name">Veoh</span>
        </div> */}

        <div 
          className="supported-site"
          onClick={() => handleSiteClick('BuzzVideo')}
          style={{ cursor: 'pointer' }}
        >
          <img
            src="/assets/buzzideo.svg"
            alt=""
            className="supported-site__icon"
          />
          <span className="supported-site__name">BuzzVideo</span>
        </div>

        <div 
          className="supported-site"
          onClick={() => handleSiteClick('ESPN')}
          style={{ cursor: 'pointer' }}
        >
          <img
            src="/assets/espn.svg"
            alt=""
            className="supported-site__icon"
          />
          <span className="supported-site__name">ESPN</span>
        </div>

        <div 
          className="supported-site"
          onClick={() => handleSiteClick('Flickr')}
          style={{ cursor: 'pointer' }}
        >
          <img
            src="/assets/filker.svg"
            alt=""
            className="supported-site__icon"
          />
          <span className="supported-site__name">Flickr</span>
        </div>

        <div 
          className="supported-site"
          onClick={() => handleSiteClick('imgur')}
          style={{ cursor: 'pointer' }}
        >
          <img
            src="/assets/imdb.svg"
            alt=""
            className="supported-site__icon"
          />
          <span className="supported-site__name">imgur</span>
        </div>

        <div 
          className="supported-site"
          onClick={() => handleSiteClick('LinkedIn')}
          style={{ cursor: 'pointer' }}
        >
          <img
            src="/assets/linkedin.svg"
            alt=""
            className="supported-site__icon"
          />
          <span className="supported-site__name">LinkedIn</span>
        </div>

        {/* <div 
          className="supported-site"
          onClick={() => handleSiteClick('Pinterest')}
          style={{ cursor: 'pointer' }}
        >
          <img
            src="/assets/pinterest.svg"
            alt=""
            className="supported-site__icon"
          />
          <span className="supported-site__name">Pinterest</span>
        </div> */}

        <div 
          className="supported-site"
          onClick={() => handleSiteClick('Snapchat')}
          style={{ cursor: 'pointer' }}
        >
          <img
            src="/assets/snapchat.svg"
            alt=""
            className="supported-site__icon"
          />
          <span className="supported-site__name">Snapchat</span>
        </div>

        <div 
          className="supported-site"
          onClick={() => handleSiteClick('All Video Downloader')}
          style={{ cursor: 'pointer' }}
        >
          <img
            src="/assets/appImg.png"
            alt=""
            className="supported-site__icon"
          />
          <span className="supported-site__name">Vidow</span>
        </div>
      </div>
    </section>
  );
};

export default WebsiteSupported;
